import { ViewStyle } from 'react-native';

export function getTriangleAlignItems(
  isFirst: boolean,
  isLast: boolean,
): ViewStyle['alignItems'] {
  if (isFirst) {
    return 'flex-start';
  }
  if (isLast) {
    return 'flex-end';
  }
  return 'center';
}
